<template>
  <!-- URL dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-paperclip</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertURL.addEditURL'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertURL.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.urlName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.urlName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.detail'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.detail'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.detail'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.url'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                prefix="https://"
                outlined
                :rules="urlRules"
                clearable
                @change="clearUrl"
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertURL.url'
                  )
                "
                v-model="url"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
                <v-col>
                  <p>ตัวอย่างเว็บไซต์</p>
                  <iframe class="iframeWeb" :src="url"></iframe>
                </v-col>
          </v-row>-->
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="validate"
          :disabled="!valid"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { insertLecture, updateLecture } from '@/service/course/course.js';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {
      valid: true,

      title: '',
      description: '',
      url: '',

      maxWidth: '40%',
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertURL.pleaseFillName'
          ),
      ],
      urlRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertURL.urlPlH'
          ),
      ],

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
    };
  },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   this.url = filterLecture.url;
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          console.log(filterLecture.url[0]);
          let tempURL = '';
          if (filterLecture.url) {
            // filterLecture.url[0] = filterLecture.url[0].toLowerCase();
            console.log(filterLecture.url[0]);
            let tmphttps = filterLecture.url[0].indexOf('http');
            console.log(tmphttps);
            if (tmphttps > -1) {
              tempURL = filterLecture.url[0];
              tempURL = tempURL.replace('https://', '');
              tempURL = tempURL.replace('http://', '');
            }
          }
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          this.url = tempURL;
          this.oldValue = filterLecture;
        } else {
          this.title = '';
          this.description = '';
          this.url = '';
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
          this.oldValue = [];
          this.warnningToSaveDialog = false;
        }
      }
    },
  },
  methods: {
    async validate() {
      this.warnningToSaveDialog = false;
      let tmpUrl = null;
      if (this.url) {
        // this.url = this.url.toLowerCase();
        let tmphttps = this.url.indexOf('http');
        if (tmphttps > -1) {
          this.url = this.url.replace('https://', '');
          this.url = this.url.replace('http://', '');
        }
        tmpUrl = 'https://' + this.url;
      }
      if (this.$refs.form.validate()) {
        if (!this.lectureId) {
          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            url: [tmpUrl],
            type: 'URL',
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            url: tmpUrl,
            type: 'URL',
          });
        }
        this.closeLectureDialog();
      }
    },
    checkToSave() {
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.url !== this.oldValue.url
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      } else {
        this.title !== '' || this.description !== '' || this.url !== ''
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      }
    },
    clearUrl() {
      if (this.url) {
        // this.url = this.url.toLowerCase();
        let tmphttps = this.url.indexOf('http');
        if (tmphttps > -1) {
          this.url = this.url.replace('https://', '');
          this.url = this.url.replace('http://', '');
        }
      }
    },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
